module.exports = __webpack_public_path__ + "img/download-icon-audio.cb811701.svg";